import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Accordion,
  Radio,
  SimpleGrid,
  ActionIcon,
  Textarea,
  Select,
  NumberInput,
} from "@mantine/core";
import { IconChevronDown, IconPlus } from "@tabler/icons-react";
import { DatePickerInput } from "@mantine/dates";
import useStyles from "./style";
import { IoClose } from "react-icons/io5";
import { IconX } from "@tabler/icons-react";
import { decrypt } from "../../utils";
import { FiMinus, FiPlus } from "react-icons/fi";

const UpdateAndViewEssentialSupport = ({
  setSelectedFacility,
  setSelected,
  view,
  data,
  carePlanType,
  essentialSupportData,
  setEssentialSupportData,
}) => {
  const [openedEssentialAccordion, setOpenedEssentialAccordion] =
    useState(null);

  const [selectedPlanType, setSelectedPlanType] = useState(null);

  // Initial structure for outcomes
  const initialOutcome = {
    outcomeCategory: "",
    outcomeTitle: "",
    customOutcome: "",
    outcomeDescription: "",
    additionalInformation: "",
    outcomeNumber: "",
    keySteps: [{ id: Date.now(), text: "" }],

    activities: [
      {
        id: Date.now(),
        activity: "",
        supportInstructions: "",
        skillBuilding: "no",
        skillBuildingText: "",
        intensiveInHome: "no",
        activityNumber: "1a",
      },
    ],
    howOften: "",
    iNoLongerNeedThisOutcome: "",
  };

  const [outcome, setOutcome] = useState([
    { id: Date.now(), ...initialOutcome, outcomeNumber: 1 },
  ]);
  // Initial structure for essential support
  const initialEssentialSupport = {
    essentialSupportType: "",
    howOftenEssentialSupport: "",
    supportStatement: "",
    howToSupport: "",
    activityNumber: "1a",
    activities: [
      {
        id: Date.now(),
        howToSupport: "",
        supportStatement: "",
        activity: "",
        activityNumber: "1a",
      },
    ],
  };
  const [essentialSupportAdded, setEssentialSupportAdded] = useState(
    essentialSupportData ? "yes" : "no"
  );
  // const [essentialSupportData, setEssentialSupportData] = useState(null);
  const [essentialSupport, setEssentialSupport] = useState([
    { id: Date.now(), ...initialEssentialSupport, activityNumber: 2 },
  ]);

  const { classes } = useStyles();

  const alphabet = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  // Handle essential activity change
  const handleEssentialActivityChange = (
    supportId,
    activityId,
    field,
    value
  ) => {
    // setEssentialSupport((prev) =>
    setEssentialSupportData((prev) =>
      prev.map((support) =>
        support.id === supportId
          ? {
              ...support,
              activities: support.activities.map((act) =>
                act.id === activityId ? { ...act, [field]: value } : act
              ),
            }
          : support
      )
    );
  };

  // essential support handler function
  const handleEssentialSupportChange = (supportId, field, value) => {
    setEssentialSupportData((prev) =>
      prev.map((support) =>
        support.id === supportId ? { ...support, [field]: value } : support
      )
    );
  };

  // Add essential support activity
  const addEssentialActivity = (supportId, activityIndex) => {
    setEssentialSupportData((prev) =>
      prev.map((support) =>
        support.id === supportId
          ? {
              ...support,
              activities: [
                ...support.activities,
                {
                  ...initialEssentialSupport,
                  id: Date.now(),
                  activityNumber: `${support.activities.length + 1}${
                    alphabet[activityIndex]
                  }`,
                },
              ],
            }
          : support
      )
    );
  };

  // Remove essential support activity
  const removeEssentialActivity = (supportId, activityId) => {
    setEssentialSupportData((prev) =>
      prev.map((support) =>
        support.id === supportId
          ? {
              ...support,
              activities: support.activities.filter(
                (act) => act.id !== activityId
              ),
            }
          : support
      )
    );
  };

  useEffect(() => {
    if (carePlanType) {
      setSelectedPlanType(carePlanType);
      setSelected(carePlanType);
      // setOpenedAccordion("0");
    }
  }, [carePlanType]);

  useEffect(() => {
    if (data) {
      setEssentialSupportAdded(data?.essentialSupport?.length ? "yes" : "no");
      if (data?.essentialSupport) {
        setEssentialSupportData(data?.essentialSupport);
      }
    }
  }, [data]);

  return (
    <>
      <Box ml={20} mt={20}>
        <Text>Add Essential Support</Text>
        {view ? (
          <Box className={classes.essentialSupportRadio}>
            <Radio.Group value={essentialSupportAdded}>
              <Flex gap={10} align="center">
                <Radio
                  disabled={true}
                  value="yes"
                  label="Yes"
                  color="gray"
                  variant="outline"
                />
                <Radio
                  disabled={true}
                  value="no"
                  label="No"
                  color="gray"
                  variant="outline"
                />
              </Flex>
            </Radio.Group>
          </Box>
        ) : (
          <Box className={classes.essentialSupportRadio}>
            <Radio.Group
              value={essentialSupportAdded}
              onChange={(value) => {
                setEssentialSupportAdded(value);
                if (value === "yes") {
                  const newSupport = {
                    id: Date.now(),
                    activities: [
                      {
                        id: Date.now(),
                        howToSupport: "",
                        supportStatement: "",
                        activity: "",
                        activityNumber: "1a",
                      },
                    ],
                  };
                  setEssentialSupportData([newSupport]);
                  setOpenedEssentialAccordion(newSupport?.id?.toString());
                }
              }}
            >
              <Flex gap={10} align="center">
                <Radio value="yes" label="Yes" color="gray" variant="outline" />
                <Radio
                  onClick={() => setEssentialSupportData([])}
                  value="no"
                  label="No"
                  color="gray"
                  variant="outline"
                />
              </Flex>
            </Radio.Group>
          </Box>
        )}
      </Box>

      {essentialSupportAdded === "yes" && (
        <Box ml={20} mt={10}>
          <Text size="sm" fw={500} mb="sm">
            Essential Support Details
          </Text>
          <>
            <Accordion
              value={openedEssentialAccordion}
              onChange={setOpenedEssentialAccordion}
              chevron={<IconChevronDown size={34} color="gray" />}
              chevronPosition="right"
              styles={{
                chevron: {
                  "&[data-active]": { transform: "rotate(180deg)" },
                },
              }}
            >
              {essentialSupportData?.map((support, index) => {
                return (
                  <Accordion.Item
                    key={index}
                    value={
                      support?.id ? support.id.toString() : "default-value"
                    }
                  >
                    <Accordion.Control>
                      <Text fw={600}>{`Essential Support #${
                        support?.essentialNumber || index + 1
                      }`}</Text>
                    </Accordion.Control>
                    <Accordion.Panel>
                      <>
                        <Flex align="end" justify="flex-end" mb={10}>
                          {!view && (
                            <Button
                              variant="light"
                              color="red"
                              onClick={() => {
                                if (essentialSupportData?.length > 1) {
                                  setEssentialSupportData((prev) =>
                                    prev.filter(
                                      (item) => item.id !== support?.id
                                    )
                                  );
                                }
                              }}
                            >
                              Delete
                            </Button>
                          )}
                        </Flex>
                        <Box className={classes.essentialSupportNumberBox}>
                          <ActionIcon
                            size="lg"
                            disabled={view}
                            onClick={() =>
                              handleEssentialSupportChange(
                                support.id,
                                "essentialNumber",
                                Math.max(1, (support.essentialNumber || 1) - 1)
                              )
                            }
                          >
                            <Button
                              variant="default"
                              size="xs"
                              w={40}
                              h={40}
                              style={{ borderRadius: "50%" }}
                            >
                              <FiMinus size={15} />
                            </Button>
                          </ActionIcon>
                          <NumberInput
                            className={classes.myfont}
                            size="xl"
                            variant="unstyled"
                            value={support?.essentialNumber || index + 1}
                            onChange={(value) => {
                              handleEssentialSupportChange(
                                support?.id,
                                "essentialNumber",
                                value
                              );
                            }}
                            placeholder="Enter outcome number"
                            required
                            disabled={view}
                          />
                          <ActionIcon
                            size="lg"
                            disabled={view}
                            onClick={() =>
                              handleEssentialSupportChange(
                                support.id,
                                "essentialNumber",
                                (support.essentialNumber || 1) + 1
                              )
                            }
                          >
                            <Button
                              variant="default"
                              size="xs"
                              w={40}
                              h={40}
                              style={{ borderRadius: "50%" }}
                            >
                              <FiPlus size={15} />
                            </Button>
                          </ActionIcon>
                        </Box>
                        <SimpleGrid
                          cols={3}
                          mb="md"
                          className={classes.essentialSupportFieldBox}
                        >
                          {view ? (
                            <Select
                              label="Essential Support Type"
                              placeholder="Select Essential Support Type"
                              defaultValue={support?.supp}
                              disabled={true}
                              data={[
                                "Identified Risk",
                                "Potential Risk",
                                "Routine Support",
                              ]}
                              value={support?.essentialSupportType}
                              rightSection={
                                <IconChevronDown size={24} color="gray" />
                              }
                            />
                          ) : (
                            <Select
                              label="Essential Support Type"
                              placeholder="Select Essential Support Type"
                              value={support?.essentialSupportType}
                              onChange={(value) =>
                                handleEssentialSupportChange(
                                  support.id,
                                  "essentialSupportType",
                                  value
                                )
                              }
                              data={[
                                "Identified Risk",
                                "Potential Risk",
                                "Routine Support",
                              ]}
                              // value={support?.essentialSupportType}
                              rightSection={
                                <IconChevronDown size={24} color="gray" />
                              }
                            />
                          )}
                          {view ? (
                            <Select
                              label="How Often"
                              placeholder="Select option"
                              disabled={true}
                              rightSection={
                                <IconChevronDown size={24} color="gray" />
                              }
                              data={[
                                "Daily",
                                "Weekly",
                                "Monthly",
                                "Quarterly",
                                "Semi-annually",
                                "Annually",
                                "Routinely as needed",
                                "Emergency support only",
                              ]}
                              defaultValue={support?.howOftenEssentialSupport}
                            />
                          ) : (
                            <Select
                              label="How Often"
                              placeholder="Select option"
                              disabled={view ? true : false}
                              defaultValue={support?.howOftenEssentialSupport}
                              rightSection={
                                <IconChevronDown size={24} color="gray" />
                              }
                              data={[
                                "Daily",
                                "Weekly",
                                "Twice a Week",
                                "Monthly",
                                "Twice a Month",
                              ]}
                              onChange={(value) =>
                                handleEssentialSupportChange(
                                  support.id,
                                  "howOftenEssentialSupport",
                                  value
                                )
                              }
                            />
                          )}
                          {view ? (
                            <DatePickerInput
                              defaultValue={
                                Array.isArray(support?.effectivePeriods)
                                  ? [
                                      new Date(support?.effectivePeriods[0]),
                                      new Date(support?.effectivePeriods[1]),
                                    ]
                                  : [new Date(), new Date()]
                              }
                              type="range"
                              label="Effective Periods"
                              placeholder="Select start and end dates"
                              disabled={true}
                            />
                          ) : (
                            <DatePickerInput
                              defaultValue={
                                Array.isArray(support?.effectivePeriods)
                                  ? [
                                      new Date(support?.effectivePeriods[0]),
                                      new Date(support?.effectivePeriods[1]),
                                    ]
                                  : [new Date(), new Date()]
                              }
                              type="range"
                              label="Effective Periods"
                              placeholder="Select start and end dates"
                              // defaultValue={support?.effectivePeriods}
                              onChange={(value) =>
                                handleEssentialSupportChange(
                                  support.id,
                                  "effectivePeriods",
                                  value
                                )
                              }
                            />
                          )}
                        </SimpleGrid>
                        <h3>Essential Support Activities</h3>
                        {support?.activities?.map((activity, actIndex) => (
                          <Box
                            key={actIndex}
                            className={classes.essentialActivities}
                          >
                            {/* ----- 1a ----- */}
                            <Box className={classes.oneA}>
                              {`${support?.essentialNumber || actIndex + 1}${
                                alphabet[actIndex]
                              }` || actIndex + 1}
                            </Box>
                            {/* ----- Support Statement and How To Support ----- */}
                            <Box className={classes.statementAndSupport}>
                              <Box className={classes.statementSupportParent}>
                                {/* ----- Support Statement ----- */}
                                <Box className={classes.supportBox}>
                                  <Text>Support Statement</Text>
                                  {view ? (
                                    <Textarea
                                      disabled={true}
                                      defaultValue={activity?.supportStatement}
                                      // value={activity?.supportStatement}
                                      onChange={(e) =>
                                        handleEssentialActivityChange(
                                          support?.id,
                                          activity?.id,
                                          "supportStatement",
                                          e.target.value
                                        )
                                      }
                                      minRows={5}
                                      placeholder="Enter support statement"
                                      className={
                                        classes.statementSupportTextArea
                                      }
                                    />
                                  ) : (
                                    <Textarea
                                      defaultValue={activity?.supportStatement}
                                      disabled={view ? true : false}
                                      onChange={(e) =>
                                        handleEssentialActivityChange(
                                          support?.id,
                                          activity?.id,
                                          "supportStatement",
                                          e.target.value
                                        )
                                      }
                                      minRows={5}
                                      placeholder="Enter support statement"
                                      className={
                                        classes.statementSupportTextArea
                                      }
                                    />
                                  )}
                                </Box>
                                {/* ----- How To Support ----- */}
                                <Box
                                  className={`${classes.supportBox} ${classes.instructionsBox}`}
                                >
                                  <Text>How To Support</Text>
                                  {view ? (
                                    <Textarea
                                      disabled={true}
                                      value={activity?.howToSupport}
                                      minRows={5}
                                      placeholder="Enter support instructions"
                                      className={
                                        classes.statementSupportTextArea
                                      }
                                    />
                                  ) : (
                                    <Textarea
                                      defaultValue={activity?.howToSupport}
                                      disabled={view ? true : false}
                                      onChange={(e) =>
                                        handleEssentialActivityChange(
                                          support.id,
                                          activity?.id,
                                          "howToSupport",
                                          e.target.value
                                        )
                                      }
                                      minRows={5}
                                      placeholder="Enter support instructions"
                                      className={
                                        classes.statementSupportTextArea
                                      }
                                    />
                                  )}
                                </Box>
                              </Box>
                              {!view && (
                                <Box className={classes.addNewActivityParent}>
                                  {support?.activities?.length > 1 && (
                                    <ActionIcon
                                      disabled={view ? true : false}
                                      color="red"
                                      variant="light"
                                      onClick={() =>
                                        removeEssentialActivity(
                                          support?.id,
                                          activity?.id
                                        )
                                      }
                                    >
                                      <IoClose />
                                    </ActionIcon>
                                  )}
                                  {actIndex ===
                                    support?.activities?.length - 1 && (
                                    <ActionIcon
                                      disabled={view ? true : false}
                                      color="yellow"
                                      variant="filled"
                                      onClick={() =>
                                        addEssentialActivity(
                                          support.id,
                                          actIndex
                                        )
                                      }
                                    >
                                      <IconPlus />
                                    </ActionIcon>
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        ))}
                      </>
                    </Accordion.Panel>
                  </Accordion.Item>
                );
              })}
            </Accordion>
            {!view && (
              <Button
                size="sm"
                color="yellow"
                onClick={() => {
                  const newSupport = {
                    id: Date.now(),
                    ...initialEssentialSupport,
                    essentialNumber:
                      essentialSupportData?.slice(-1)[0]?.essentialNumber + 1,

                    activities: [
                      {
                        id: Date.now(),
                        howToSupport: "",
                        supportStatement: "",
                        activity: "",
                        activityNumber: "1a",
                      },
                    ],
                  };
                  setEssentialSupportData((prev) => [...prev, newSupport]);
                  setOpenedEssentialAccordion(newSupport.id.toString());
                }}
                style={{ float: "right", margin: "1rem" }}
              >
                Add More Support Details
              </Button>
            )}
          </>
        </Box>
      )}
    </>
  );
};

export default UpdateAndViewEssentialSupport;
